import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import ContributiiImg from "../images/contributii-img.png";
import "../css/main.css";

const Blog = () => {
  return (
    <div>
      <Header />

      <div className="contributii blog">
        <div className="container">
          <div className="info-section text-b">AWARE</div>
          <h1 className="text-b">Blog</h1>
          <div className="row box">
            <div className="blog-post">
              <div className="blog-title">
                Titlu despre psihologia cognitiva
              </div>
              <div className="blog-image">
                <img src={ContributiiImg} alt="contributii" />
              </div>
              <div className="blog-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
                leo eros, eleifend et nibh id, eleifend pharetra mi. Phasellus
                quis fermentum tellus. Mauris metus arcu, accumsan nec arcu eu,
                molestie faucibus turpis. Nunc convallis commodo ipsum, et
                semper ante sagittis quis. Cras viverra bibendum purus non
                convallis. Nam interdum tempor consectetur. Fusce tortor nulla,
                convallis ac ornare eu, tempus ac lectus. Nulla ut iaculis quam.
                Nulla varius metus eget pharetra lobortis.
              </div>
            </div>
            <div className="column aside">
              <h3>Alte postari</h3>
              <div className="recent-posts">
                <div className="post">
                  <div className="image">
                    <img src={ContributiiImg} alt="contributii" />
                  </div>
                  <div className="column">
                    <div className="title">Titlu despre orice test</div>
                    <div className="description">
                      bla bla bla blabla bla bla blabla bla bla blabla bla bla
                      blabla bla bla bla bla bla bla blabla bla bla blabla bla
                      bla blabla bla bla blabla bla bla bla bla bla bla blabla
                      bla bla blabla bla bla blabla bla bla blabla bla bla bla
                      bla bla bla blabla bla bla blabla bla bla blabla bla bla
                      blabla bla bla bla
                    </div>
                    <a href="/" className="see-more">
                      Vezi mai mult >
                    </a>
                  </div>
                </div>
                <div className="post">
                  <div className="image">
                    <img src={ContributiiImg} alt="contributii" />
                  </div>
                  <div className="column">
                    <div className="title">Titlu despre orice test</div>
                    <div className="description">
                      bla bla bla blabla bla bla blabla bla bla blabla bla bla
                      blabla bla bla bla bla bla bla blabla bla bla blabla bla
                      bla blabla bla bla blabla bla bla bla bla bla bla blabla
                      bla bla blabla bla bla blabla bla bla blabla bla bla bla
                      bla bla bla blabla bla bla blabla bla bla blabla bla bla
                      blabla bla bla bla
                    </div>
                    <a href="/" className="see-more">
                      Vezi mai mult >
                    </a>
                  </div>
                </div>
                <div className="post">
                  <div className="image">
                    <img src={ContributiiImg} alt="contributii" />
                  </div>
                  <div className="column">
                    <div className="title">Titlu despre orice test</div>
                    <div className="description">
                      bla bla bla blabla bla bla blabla bla bla blabla bla bla
                      blabla bla bla bla bla bla bla blabla bla bla blabla bla
                      bla blabla bla bla blabla bla bla bla bla bla bla blabla
                      bla bla blabla bla bla blabla bla bla blabla bla bla bla
                      bla bla bla blabla bla bla blabla bla bla blabla bla bla
                      blabla bla bla bla
                    </div>
                    <a href="/" className="see-more">
                      Vezi mai mult >
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;
